document.addEventListener('DOMContentLoaded', () => {
    const heroSwiper = new Swiper('.hero-swiper', {
		loop: false,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		rewind: true,
		autoplay: {
			delay: 4000
		},
	});

	const sliderSwiper = new Swiper('.slider-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: '.slider-next',
			prevEl: '.slider-prev',
		}
	});


	const sliderTwoSwiper = new Swiper('.slider-two-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		pagination: {
			el: ".sw-dots",
			clickable: true,
		}
	});

	const reviewsSwiper = new Swiper('.reviews-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: '.reviews-next',
			prevEl: '.reviews-prev',
		},
	});

	const amenitiesSwiper = new Swiper('.amenities-swiper', {
		spaceBetween: 180,
		loop: true,
		centeredSlides: true,
		navigation: {
			nextEl: '.sw-next',
			prevEl: '.sw-prev',
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
				speed: 1,
			},
			900: {
				slidesPerView: 3,
				speed: 600,
			}
		}
	});

	const roomImgSwiper = new Swiper('.rooms-imgs-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: '.sw-btn-next',
			prevEl: '.sw-btn-prev',
		}
	});

	const carouselTextSwiper = new Swiper('.carousel-text', {
		loop: true,
		allowTouchMove: false,
		speed: 800,
		slidesPerView: "auto",
		navigation: {
			nextEl: '.carousel-next',
			prevEl: '.carousel-prev',
		},
	});

	const carouselImgSwiper = new Swiper('.carousel-images', {
		slidesPerView: 1,
		loop: true,
		speed: 800,
		allowTouchMove: false,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: '.carousel-next',
			prevEl: '.carousel-prev',
		},	
	});

	const carouselMobileSwiper = new Swiper('.carousel-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		pagination: {
			el: ".carousel-dots",
			clickable: true,
		}	
	});


	const gallerySwiper = new Swiper('.gallery-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: '.sw-btn-next',
			prevEl: '.sw-btn-prev',
		}
	});
});